import { createContext, useContext } from 'react';

/**
 * A busca global (⌘K) vive no shell, mas quem dispara é o WorkspaceHeader de
 * cada tela. Este contexto evita passar o callback por todas as rotas.
 */
export const SearchContext = createContext<{ openSearch: () => void }>({
  openSearch: () => {},
});

export function useGlobalSearch() {
  return useContext(SearchContext);
}
